import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </M>
  );
}

export function SectionLabel({ index, children }) {
  return (
    <div className="flex items-center gap-4 mb-6">
      {index && <span className="font-serif text-gold text-lg">{index}</span>}
      <span className="h-px w-8 bg-[color:var(--relumia-champagne)]" />
      <span className="overline">{children}</span>
    </div>
  );
}
